export const tr = {
    'page-common-error': 'Hata oluştu',
    'page-common-error-hint': 'Sayfayı yenileyin veya daha sonra tekrar deneyin',
    'save-campaigns-error':
        "Kampanya kaydedilirken hata oluştu. Lütfen, tekrar deneyin ve hata tekrarlanırsa Destek Ekibi'ne başvurun.",
    'warning-about-changes': 'Değişiklikler kaydedilmeyecek. Devam etmek istiyor musunuz?'
};
